<template>
  <div
      class="z-10 absolute bg-white  px-5 py-3 sm:rounded-lg shadow-xl  border w-72 text-center mt-1"
      :style="{ '--popout-column-definition': `repeat(${columnCount}, 1fr)` }"
      @mousedown.prevent
  >
    <div class="w-full flex h-10 leading-10 font-bold">
      <button
          class="flex items-center justify-center w-5 disabled:opacity-40 hover:bg-gray-200 rounded-md"
          :disabled="leftDisabled" @click.stop.prevent="$emit('left')"
      >
        <slot name="arrow-left">
          <chevron-left-icon class="h-4 w-4"/>
        </slot>
      </button>
      <component
          :is="headingClickable ? 'button' : 'span'"
          class="rounded-md hover:bg-gray-200 flex-1"
          @click.stop.prevent="$emit('heading')"
      >
        <slot name="heading"/>
      </component>
      <button
          class="flex items-center justify-center w-5 disabled:opacity-40 hover:bg-gray-200 rounded-md"
          :disabled="rightDisabled" @click.stop.prevent="$emit('right')"
      >
        <slot name="arrow-right">
          <chevron-right-icon class="h-4 w-4"/>
        </slot>
      </button>
    </div>
    <div>
      <template v-if="'subheading' in $slots">
        <div class="v3dp__subheading grid mt-2 text-sm">
          <slot name="subheading"/>
        </div>
        <hr class="my-1"/>
      </template>
      <div class="v3dp__elements grid text-sm">
        <slot name="body">
          <button class="rounded-md m-0.5 px-0.5 py-1 disabled:opacity-40"
                  v-for="item in items" :key="item.key" :disabled="item.disabled"
                  :class="{
                'bg-primary-500 text-white': item.selected,
                'bg-primary-100': item.today,
                'hover:bg-gray-200': (!item.disabled && !(item.selected)) }"
                  @click.stop.prevent="$emit('elementClick', item.value)"
          >
            <span class="block leading-7 h-7">{{ item.display }}</span>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import {isValid} from 'date-fns';
import {defineComponent} from 'vue';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/outline'

export default defineComponent({
  components: {ChevronLeftIcon, ChevronRightIcon},
  emits: {
    elementClick: (value) => isValid(value),
    left: () => true,
    right: () => true,
    heading: () => true,
  },
  props: {
    headingClickable: {
      type: Boolean,
      default: false,
    },
    leftDisabled: {
      type: Boolean,
      default: false,
    },
    rightDisabled: {
      type: Boolean,
      default: false,
    },
    columnCount: {
      type: Number,
      default: 7,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style lang="scss">
/*
.v3dp__clearable {
  display: inline;
  position: relative;
  left: -15px;
  cursor: pointer;
}*/


.v3dp__subheading,
.v3dp__elements {
  grid-template-columns: var(--popout-column-definition);
}

</style>
